import React, { ReactNode } from 'react';
import { Select, Spin } from 'antd';

interface SearchableDropdownProps {
  id?: string;
  labelKey?: string;
  options: { label; value }[];
  onChange: (value: string | number) => void;
  placeholder?: string;
  selected?: (string | number)[];
  style?: React.CSSProperties;
  size?: 'small' | 'middle' | 'large';
  showSearch?: boolean;
  allowClear?: boolean;
  isWeek?: boolean;
  showArrow?: boolean;
  disabled?: boolean;
  optionRender?: (option: any) => ReactNode;
  dropDownStyle?: React.CSSProperties;
  loading?: boolean;
}

const SearchableDropdown: React.FC<SearchableDropdownProps> = ({
  id,
  options,
  onChange,
  placeholder,
  selected,
  style,
  showSearch = true,
  allowClear = true,
  isWeek = false,
  showArrow = false,
  disabled,
  optionRender,
  dropDownStyle,
  loading = false,
}) => {
  return (
    <Select
      id={id}
      showSearch={showSearch}
      allowClear={allowClear}
      style={{ width: '100%', ...style }}
      placeholder={placeholder}
      filterOption={(input, option) =>
        (option?.label ?? '')
          .toString()
          .toLowerCase()
          .includes(input.toLowerCase())
      }
      options={options}
      onChange={onChange}
      value={selected?.length ? selected[0] : undefined}
      className="custom-bordered-input"
      disabled={disabled}
      showArrow={showArrow}
      optionRender={optionRender}
      dropdownStyle={dropDownStyle}
      notFoundContent={
        loading ? (
          <div style={{ textAlign: 'center', padding: '12px' }}>
            Loading...
            <Spin style={{ marginLeft: '8px' }} size="small" />
          </div>
        ) : (
          <div style={{ textAlign: 'center', padding: '12px' }}>No data</div>
        )
      }
    />
  );
};

export default SearchableDropdown;
